import Link from "next/link";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import styles from "./Footer.module.scss";
import Cookie from "../../mainNew/cookie";
import { getLandingLogoFromHost } from "/utils/landingLogo";

export default function Footer() {
  const { host } = useSelector((state) => state.params);
  const { contacts } = useSelector((state) => state.contacts);

  const phone = useMemo(() => {
    return contacts?.phone;
  }, [contacts]);

  const landingLogoText = useMemo(
    () => (host ? getLandingLogoFromHost(host) : "Farkop.ru"),
    [host],
  );

  return (
    <div className={styles.Footer}>
      <div className="container">
        <div className={styles.Colomns}>
          <div className={styles.Info}>
            <Link href="/">
              <a className={styles.Logo}>
                <span className={styles.LogoText}>{landingLogoText}</span>
              </a>
            </Link>

            <div className={styles.Contacts}>
              {phone && (
                <a href={`tel:${phone}`} className={contacts?.calltouchCode}>
                  {phone}
                </a>
              )}
              <a href="mailto:info@farkop.ru">info@farkop.ru</a>
            </div>
          </div>

          <div className={styles.MenuBlock}>
            <span className={styles.ColomnTitle}>Каталог</span>
            <ul>
              <li>
                <Link href="/catalog/farkopy/">Фаркопы</Link>
              </li>
              <li>
                <Link href="/catalog/elektrika_farkopov/">
                  Электрика фаркопа
                </Link>
              </li>
            </ul>
          </div>

          <div className={styles.MenuBlock}>
            <span className={styles.ColomnTitle}>Услуги</span>
            <ul>
              <li>
                <Link href="/services/ustanovka-farkopa/">
                  Установка фаркопа
                </Link>
              </li>
              <li>
                <Link href="/services/ustanovka-elektriki-farkopa/">
                  Установка электрики
                </Link>
              </li>
            </ul>
          </div>

          <div className={styles.MenuBlock}>
            <span className={styles.ColomnTitle}>Покупателям</span>
            <ul>
              <li>
                <Link href="/faq/">Вопросы и ответы</Link>
              </li>
              <li>
                <Link href="/shops/">Мы на карте</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.Privacy}>
          <Link href="/privacy/">Пользовательское соглашение</Link>
        </div>

        <div className={styles.Copy}>
          <div>© 2010–{new Date().getFullYear()} Фаркоп.ру</div>
        </div>
      </div>
      <Cookie />
    </div>
  );
}
